module.exports = __webpack_public_path__ + "static/media/CTALeft.644ac171.svg";